import React, { useEffect, useMemo, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import TablesService from '../../services/TablesService';
import { waiterOptions } from './tablesUtils';

/**
 * Selector de mozo: el personal asignado a la sucursal. Si el mozo actual de la cuenta (o quien opera) no está
 * asignado al local igual aparece, para no dejar la cuenta sin un valor válido.
 */
const WaiterSelect = ({ locationId, value, onChange, extraEmails = [], disabled }) => {
  const [waiters, setWaiters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    TablesService.getWaiters(locationId)
      .then((data) => active && setWaiters(data || []))
      .catch(() => active && setWaiters([]))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [locationId]);

  const options = useMemo(() => waiterOptions(waiters, [value, ...extraEmails]), [waiters, value, extraEmails]);

  return (
    <TextField
      select
      fullWidth
      size="small"
      label="Mozo"
      value={value || ''}
      disabled={disabled || loading}
      onChange={(event) => onChange(event.target.value)}
      helperText={loading ? 'Cargando personal…' : undefined}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default WaiterSelect;
